<template>
  <div
    id="kt_modal_parametros_consulta_relatorio"
    ref="kt_modal_parametros_consulta_relatorio"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Filtro
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div
            class="col-auto mb-4"
            v-for="parametro in parametros"
            :key="parametro"
          >
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-2"
            >
              <label
                v-if="parametro.tipo !== 'System.Boolean'"
                class="required form-label"
                >{{ parametro.descricao }}</label
              >
              <input
                v-if="
                  parametro.tipo === 'System.Int16' ||
                  parametro.tipo === 'System.Int32' ||
                  parametro.tipo === 'System.Int64' ||
                  parametro.tipo === 'System.UInt16' ||
                  parametro.tipo === 'System.UInt32' ||
                  parametro.tipo === 'System.UInt64'
                "
                type="number"
                class="form-control form-control-sm mb-0"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Insira a informação que deseja filtrar"
                placeholder="Insira um valor numérico"
                v-model="parametro.valor"
              />
              <CurrencyInput
                v-else-if="
                  parametro.tipo === 'System.Decimal' ||
                  parametro.tipo === 'System.Double'
                "
                class="form-control form-control-sm mb-0"
                placeholder="Insira um valor numérico"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Insira a informação que deseja filtrar"
                style="text-align: right"
                :options="options"
                v-model="parametro.valor"
              ></CurrencyInput>
              <input
                v-else-if="parametro.tipo === 'System.TimeSpan'"
                type="text"
                class="form-control form-control-sm mb-0"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Insira a informação que deseja filtrar"
                placeholder="Informe a hora"
                v-mask="'##:##:##'"
                v-model="parametro.valor"
              />
              <el-date-picker
                v-else-if="parametro.tipo === 'System.DateTime'"
                type="datetime"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Insira a informação que deseja filtrar"
                class="w-100"
                placeholder="Informe uma data"
                format="DD/MM/YYYY HH:mm:ss"
                v-model="parametro.valor"
              />
              <div
                class="form-check"
                v-else-if="parametro.tipo === 'System.Boolean'"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  :checked="parametro.valor === '1'"
                  @change="parametro.valor = $event.target.checked ? '1' : '0'"
                />
                <label class="form-check-label" for="flexCheckChecked">
                  {{ parametro.descricao }}
                </label>
              </div>
              <input
                v-else
                type="text"
                class="form-control form-control-sm mb-0"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Insira a informação que deseja filtrar"
                placeholder="Informe o valor"
                v-model="parametro.valor"
              />
              <div
                v-if="parametro.erro"
                class="fv-plugins-message-container invalid-feedback m-0"
              >
                {{ parametro.erro }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyInput from "@/components/text/CurrencyInput";
import { useToast } from "vue-toastification";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import moment from "moment";
const toast = useToast();

export default {
  emits: ["exibirParametrosConsultaModal", "confirmarParametrosConsultaModal"],
  components: { CurrencyInput },
  props: {
    id: { type: Number, required: true },
    relatorio: { type: Object, required: false },
    parametros: { type: Object, required: false },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if (this.validar() === true) {
        hideModal(this.$refs.kt_modal_parametros_consulta_relatorio);
        this.sleep(100);
        this.$emit(
          "confirmarParametrosConsultaModal",
          this.id,
          this.parametros
        );
      } else {
        //("Verifique os erros nos campos a seguir");
      }

      this.loading = false;
    },
    validar() {
      let validou = true;
      for (const parametro of Object.values(this.parametros)) {
        if (
          parametro.tipo === "System.DateTime" ||
          parametro.tipo === "System.TimeSpan" ||
          parametro.tipo === "System.Decimal" ||
          parametro.tipo === "System.Double" ||
          parametro.tipo === "System.Int16" ||
          parametro.tipo === "System.Int32" ||
          parametro.tipo === "System.Int64" ||
          parametro.tipo === "System.UInt16" ||
          parametro.tipo === "System.UInt32" ||
          parametro.tipo === "System.UInt64"
        ) {
          if (parametro.valor === undefined || parametro.valor === null) {
            parametro.erro = "Informe um valor válido";
            validou = false;
          }
        }
      }
      return validou;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_parametros_consulta_relatorio);
      this.sleep(100);
      this.$emit("exibirParametrosConsultaModal", false);
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    this.loading = true;

    for (const parametro of Object.values(this.parametros)) {
      if (parametro.tipo === "System.DateTime") {
        if (parametro.nome.toLowerCase() === "data_inicial") {
          parametro.valor = moment()
            .startOf("month")
            .format("YYYY-MM-DD HH:mm:ss");
          console.log(parametro.valor);
        } else if (parametro.nome.toLowerCase() === "data_final") {
          parametro.valor = moment()
            .endOf("month")
            .format("YYYY-MM-DD HH:mm:ss");
          console.log("1" + parametro.valor);
        }
      } else if (parametro.tipo === "System.Boolean") {
        if (parametro.nome.toLowerCase() === "ativo") {
          parametro.valor = "1";
        }
      }
    }

    this.loading = false;
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      parametrosConfirmar: [],
      timeOut: null,
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
